import { AfterContentChecked, Component, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CfetBaseComponent, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-customer-profile',
    templateUrl: './customer-profile.component.html',
    styleUrls: ['./customer-profile.component.scss'],
    standalone: false
})
export class CustomerProfileComponent extends CfetBaseComponent implements OnInit, AfterContentChecked {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = true;
  stepTwoIcon = false;
  stepTwoSelected = false;
  stepTwoDone = true;
  stepThreeIcon = true;
  stepThreeSelected = true;
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  showStepCompleteHeading = false;
  showDesktopEditButton = false;
  showMobileEditButton = false;
  editButtonClicked: boolean;
  signupCompleted = false;
  showWorkPlaceSection = false;
  selectedRole: any;
  selectedWorkPlace: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1: number;
  divHeight2: number;
  eligibilitystoredInfo: any;
  stepTwocompleted = false;
  showTermsAndCondition = false;
  showOTPScreen = false;
  showPasswordScreen = true;
  showInactivityModal = true;
  showWeekPassword = false;

  constructor(private title: Title,
    private elementRef: ElementRef,
    private router: Router,
    private cfetService: CfetService) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.profile.htmlTitle);
    this.cfetService.isLandingPage.next(false);
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.showWorkPlaceSection = true;
      this.stepOneDone = true;
      this.signupCompleted = true;
      this.disableStep = false;
      this.stepThree();
      const isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
        || isIPadPro) {
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = false;
        this.showMobileEditButton = false;
      } else {
        this.showDesktopEditButton = false;
        this.showWorkPlaceSection = true;
        this.showMobileEditButton = false;
      }
      this.eligibilitystoredInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedRole = this.eligibilitystoredInfo['selectedRoleVal'];
      this.selectedCity = this.eligibilitystoredInfo['eligibilityStatus'].selectedCity;
      this.selectedWorkPlace = this.eligibilitystoredInfo['eligibilityStatus'].selectedName;
      this.selectedAddress = this.eligibilitystoredInfo['eligibilityStatus'].selectedAddress;
      this.selectedStateInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedStateInWorkplace.split(':')[0];
      this.selectedZipInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedZipInWorkplace;
    }
  }

  ngAfterContentChecked() {
    this.divheightCalc();
  }

  changeOrientation(event) {
    if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'landscape-primary') {
      this.showMobileEditButton = false;
      this.showDesktopEditButton = false;
      this.showWorkPlaceSection = true;
    } else if (this.signupCompleted && navigator.userAgent.match(/iPad/i) && screen.orientation.type === 'portrait-primary') {
      this.showMobileEditButton = false;
      this.showDesktopEditButton = false;
      this.showWorkPlaceSection = false;
    }
  }

  divheightCalc() {
    const divElem2 = this.elementRef.nativeElement.querySelector('#form-component-section').children[0];
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (screen.width > 801) {
      if (divElem2.scrollHeight > (93.4 * vh / 100)) {
        this.divHeight1 = divElem2.scrollHeight;
      } else {
        this.divHeight1 = 93.4 * vh / 100;
        this.divHeight2 = 93.4 * vh / 100;
      }
    } else {
      const bodyelement = this.elementRef.nativeElement.querySelector('#cutomer-profile-screen').children[0];
      const formcomponentsection = this.elementRef.nativeElement.querySelector('#form-component-section');
      const progresstrackerelement = this.elementRef.nativeElement.querySelector('#progress-tracker');
      if (bodyelement.scrollHeight <= progresstrackerelement.scrollHeight + formcomponentsection.scrollHeight) {
        const bodyheight = progresstrackerelement.scrollHeight + formcomponentsection.scrollHeight;
        bodyelement.style.height = bodyheight + 'px';
      } else {
        bodyelement.style.height = 70.4 * vh / 100 + 'px';
      }
    }
  }

  stepThree() {
    if (this.disableStep) {
      this.stepThreeSelected = false;
    } else {
      this.stepTwoSelected = false;
      this.stepOneSelected = false;
      this.stepThreeSelected = true;
    }
  }

  closeTermsPage(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.showTermsAndCondition = false;
    }
  }

  openTermsPage(event) {
    if (event) {
      this.showTermsAndCondition = true;
      window.scroll(0, 0);
    }
  }

  showCodeSection(event) {
    if (event) {
      this.showPasswordScreen = false;
      this.showOTPScreen = true;
      window.scroll(0, 0);
    }
  }

  showCompleteProfile(event) {
    if (event) {
      this.showPasswordScreen = true;
      this.showOTPScreen = false;
      this.showWeekPassword = true;
      window.scroll(0, 0);
    }
  }
}
